import { AttachmentHandleMode } from '../types/AttachmentHandleMode';

export const formAction = {
    create: 'createnewform' as AttachmentHandleMode,
    edit: 'editsavedform' as AttachmentHandleMode,
    upload: 'uploadfile' as AttachmentHandleMode,
    provideLater: 'providelater' as AttachmentHandleMode,
    willNotProvide: 'willnotprovide' as AttachmentHandleMode,
    textData: 'textdata' as AttachmentHandleMode,
};
